import React, { useEffect, useState } from "react";
import { api, fmtNum } from "@finance/lib/api";

// Dashboard tiles: inventory value + 90+ day slow-moving capital, and supplier POs past ETA.
export function OpsTiles() {
  const [inv, setInv] = useState(null);
  const [pastEta, setPastEta] = useState(null);
  const [pend, setPend] = useState(null);
  useEffect(() => {
    api.get("/fulfillment/pending-auth").then((r) => setPend(r.data?.total ?? 0)).catch(() => {});
    api.get("/inventory/aging").then((r) => setInv(r.data)).catch(() => {});
    api.get("/transactions").then((r) => {
      const today = new Date().toISOString().slice(0, 10);
      const rows = Array.isArray(r.data) ? r.data : (r.data?.items || []);
      setPastEta(rows.filter((t) => t.eta && String(t.eta).slice(0, 10) < today && !["Delivered", "Invoiced", "Reconciled", "Closed"].includes(t.status)).length);
    }).catch(() => {});
  }, []);
  const card = "rounded-sm border border-gray-200 bg-white px-5 py-4";
  return (
    <div className="mx-8 mt-6 grid grid-cols-1 gap-4 md:grid-cols-4" data-testid="ops-tiles">
      <a href="/finance/authorization-log" className={`${card} hover:shadow-sm`} data-testid="tile-pending-dn-grv"><div className="lx-label text-gray-500">Pending DN / GRV approvals</div><div className={`mt-1 lx-num text-xl font-semibold ${pend ? "text-amber-700" : ""}`}>{pend ?? "—"}</div></a>
      <div className={card} data-testid="tile-inventory-value"><div className="lx-label text-gray-500">Inventory value (AVCO)</div><div className="mt-1 lx-num text-xl font-semibold">TZS {fmtNum(inv?.total_value || 0)}</div></div>
      <div className={card} data-testid="tile-slow-moving"><div className="lx-label text-gray-500">Slow-moving (90+ days)</div><div className="mt-1 lx-num text-xl font-semibold text-amber-700">TZS {fmtNum(inv?.slow_moving_value || 0)}</div></div>
      <div className={card} data-testid="tile-past-eta"><div className="lx-label text-gray-500">POs past ETA</div><div className={`mt-1 lx-num text-xl font-semibold ${pastEta ? "text-red-600" : ""}`}>{pastEta ?? "—"}</div></div>
    </div>
  );
}
